import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {FpaEntity} from '../fpa/fpa-entity';
import {FpaScenario} from '../fpa/fpa-scenario';
import {FpaSubmissionData} from '../fpa/fpa-submission-data';
import {GoogleService} from './google-service';
import { EntityKey } from '../entity/entity-key';
import { FpaTaskData } from '../model/fpa-task-data';

@Service()
export class FpaService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public getFpaEntity(entityName: string, entityId: string, entityRevision: number): Observable<FpaEntity> {
    let url = this.urlBase + 'fpa/' + entityName + '/' + entityId + '/' + entityRevision;
    return this.http.get<FpaEntity>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  public deleteScenario(scenarioId: number): Observable<string> {
    let url = this.urlBase + 'fpa/' + scenarioId;
    return this.http.delete(url, {headers: this.getRequestHeaders(), responseType: 'text'});
  }

  public saveScenario(scenario: FpaScenario): Observable<FpaEntity> {
    let url = this.urlBase + 'fpa/saveScenario';
    let body = JSON.stringify(scenario);
    return this.http.post<FpaEntity>(url, body, {headers: this.getPostHeaders()});
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

  public submitScenarios(data: FpaSubmissionData): Observable<string> {
    let url = this.urlBase + 'fpa/submitScenarios';
    let body = JSON.stringify(data);
    return this.http.post(url, body, {headers: this.getPostHeaders(), responseType: 'text'});
  }

  public applySelection(scenario: FpaScenario): Observable<string> {
    let url = this.urlBase + 'fpa/applySelection';
    let body = JSON.stringify(scenario);
    return this.http.post(url, body, {headers: this.getPostHeaders(), responseType: 'text'});
  }

  public getAdditionalData(entityId: string, entityRevision: number): Observable<FpaSubmissionData> {
    let url = this.urlBase + 'fpa/additionalData/' + entityId + '/' + entityRevision;
    return this.http.get<FpaSubmissionData>(url, {headers: this.getRequestHeaders()});
  }

  public overrideCommission(scenario: FpaScenario): Observable<string> {
    let url = this.urlBase + 'fpa/overrideCommission';
    let body = JSON.stringify(scenario);
    return this.http.post(url, body, {headers: this.getPostHeaders(), responseType: 'text'});
  }

  isPendingApproval(status: string): Observable<string> {
    const url: string = this.urlBase + 'fpa/isPendingApproval/' + encodeURIComponent(status);
    return this.http.get(url, {headers: this.getRequestHeaders(), responseType: 'text'});
  }

  cancelSubmission(key: EntityKey): Observable<string> {
    const url: string = this.urlBase + 'fpa/cancelSubmission';
    const body: string = JSON.stringify(key);
    return this.http.post(url, body, {headers: this.getPostHeaders(), responseType: 'text'});
  }

  getAdditionalTaskData(taskId: number): Observable<FpaTaskData> {
    const url: string = this.urlBase + 'fpa/additionalTaskData/' + taskId;
    return this.http.get<FpaTaskData>(url, { headers: this.getRequestHeaders() });
  }

}
